// const { NODE_SERVER_URL, USE_UIC, UIC_URL, UIC_API_URL } = window.appConfig;
// const urlPrefix = process.env.NODE_ENV === 'dev' ? '' : NODE_SERVER_URL;
import defaultCover from './assets/images/default_over.png';

export default {
  DEFAULT_COVER: defaultCover
  // UIC_URL: 'https://account.dtstack.com/' // online
};
